import React from "react";
import './baseline-vs-finishline-report.scss';
import HomeworkForClickerPracticeApi from "../../../../apis/homework-for-clicker-practice";
import { getImageSource } from "../../../../utility/image-source";
import { ImageConstants, Constants } from "../../../../constants/constants";
import ChapterEloAssessmentReport from "./student-report/student-report-bf";
import ClassPerformanceReportBaseLineFinishLine from "./class-performance-report/class-performance-report-bf";

class BaslineVsFinishLineReport extends React.Component {

    state = {
        completedStudents: [],
        showClassPerformanceReport: false
    }

    componentDidMount() {
        this.getBaseLineFinishLineCompletedStudents()
    }


    getBaseLineFinishLineCompletedStudents() {

        let payload = {
            finishLineHomeworkId: this.props.selectedItem._id,
            baseLineHomeworkId: this.props.selectedItem.baseLineHomeworkId
        }

        HomeworkForClickerPracticeApi.getBaseLineFinishLineStudentsList(payload).then(res => {
            console.log(res)
            this.setState({ completedStudents: res.finishLineHomeworkActivity })
        }).catch(err => {
            console.log(err)
        })
    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    onClickBack() {
        this.props.delegate && this.props.delegate.hideReport && this.props.delegate.hideReport()
    }

    onShowStudentReport(user) {
        this.setState({ showStudentReport: true, selectedStudent: user, selectedHomework: this.props.selectedItem })
    }

    hideStudentReport() {
        this.setState({ showStudentReport: false })
    }

    showClassPerformanceReport(user) {
        this.setState({ showClassPerformanceReport: true, selectedHomework: this.props.selectedItem })
    }

    hideClassPerformanceReport() {
        this.setState({ showClassPerformanceReport: false })
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb-1'>
                <span>{`${this.props.selectedItem?.class} >`}</span>
                <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
                <span className='pl-2'>{`${this.props.selectedItem?.chapter} >`}</span>
                <span className='pl-2'>{this.getDate(this.props.selectedItem?.createdDateTimestamp)}</span>
            </div>
        )
    }





    render() {

        if (this.state.showStudentReport) {
            return <ChapterEloAssessmentReport
                type={this.props.selectedItem.type}
                delegate={this} selectedItem={this.state.selectedHomework}
                student={this.state.selectedStudent}
            />
        }

        if (this.state.showClassPerformanceReport) {
            return <ClassPerformanceReportBaseLineFinishLine
                type={this.props.selectedItem.type}
                delegate={this}
                selectedItem={this.state.selectedHomework}

            />
        }


        return (
            <div className="baselin-finish-line-report">
                <div className='mb-3 item1' >
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                </div>

                <div className='d-flex align-items-center justify-content-between header-report-card'>
                    <div className='d-flex align-items-center'>
                        <div>
                            <img className='circle-image' src={getImageSource(ImageConstants.EVALUATION_DETAIL_REPORT)} />
                        </div>
                        <div className='ml-2'>
                            <div className=''>
                                <span className='screen-title-1 title-center'>{`Base Line Vs Finish Line Report`}</span>
                                <span>{this.renderBreadcrumb()}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="button-wrapper " onClick={() => this.showClassPerformanceReport()}>
                    <div className="cursor-pointer start-button"  >View Class Performance Report</div>
                </div>

                <div className="pt-4 wrapper">
                    <div class="report-card border-green d-inline-block">
                        <div class="report-header background-green"><div>Students List ({this.state.completedStudents && this.state.completedStudents.length ? this.state.completedStudents.length : 0})</div></div>
                        <div className="report-body">
                            {
                                this.state.completedStudents && this.state.completedStudents.length ? this.state.completedStudents.map(student => (
                                    <div className="row py-1">
                                        <div className="col d-flex justify-content-between flex-wrap">
                                            {/* <div className="profile-avatar text-center mr-2 d-inline-block">
                                                                    <div className="row justify-content-center">
                                                                        {student.image ? <img className="" alt="img" src={`${student.basePath}${student.image}`} />
                                                                            :
                                                                            <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                                                    </div>
                                                                </div> */}
                                            <div className="pl-2 d-inline-block">
                                                <div className="student-name">{student?.studentName}</div>
                                                <div className="student-mark">Completed on {this.getDate(student.finishTime)}</div>
                                            </div>
                                            <div>
                                                <span className='d-inline'>

                                                    <img className="right-download-icon  pt-1 ml-2 cursor-pointer" src={getImageSource(ImageConstants.DOWNLOAD_ICON_BLUE)} onClick={() => this.onShowStudentReport(student)} />
                                                </span>
                                            </div>

                                        </div>
                                    </div>
                                ))
                                    :
                                    <div className="no-data text-center">
                                        <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                        <div className="empty">This is Empty</div>
                                        <div className="no-student">No Student in this bucket</div>
                                    </div>
                            }

                        </div>
                    </div>
                </div >

            </div>
        )
    }

}

export default BaslineVsFinishLineReport;